export const CONTENT_KEYWORDS = {
  CUSTOM_ARCHETYPE: "custom:",
  VISUAL_SCRIPT: "[VISUAL]",
} as const;
